module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0083.jpg?v=ff85bc4a";